"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSanduiche = void 0;
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var botao_menu_sanduiche_fragment_1 = require("./fragments/botao-menu-sanduiche/botao-menu-sanduiche.fragment");
var conteudo_menu_sanduiche_fragment_1 = require("./fragments/conteudo-menu-sanduiche/conteudo-menu-sanduiche.fragment");
var MenuSanduiche = function (_a) {
    var conteudo = _a.conteudo;
    var _b = (0, react_1.useState)(false), open = _b[0], setOpen = _b[1];
    var _c = (0, react_1.useState)(), rotaAtual = _c[0], setRotaAtual = _c[1];
    var pathname = (0, react_router_1.useLocation)().pathname;
    var toggleMenu = (0, react_1.useCallback)(function () {
        setOpen(!open);
    }, [open]);
    (0, react_1.useEffect)(function () {
        if (rotaAtual && rotaAtual !== pathname)
            setOpen(false);
        setRotaAtual(pathname);
    }, [pathname, rotaAtual]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(botao_menu_sanduiche_fragment_1.BotaoMenuSanduicheFragment, { onClick: toggleMenu }),
        open && react_1.default.createElement(conteudo_menu_sanduiche_fragment_1.ConteudoMenuSanduicheFragment, { conteudo: conteudo, onClickFecharMenu: toggleMenu, menuAberto: open })));
};
exports.MenuSanduiche = MenuSanduiche;
